
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rpvnqpqpujaalkntchry.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJwdm5xcHFwdWphYWxrbnRjaHJ5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMwMDA5MDEsImV4cCI6MjA1ODU3NjkwMX0.xV8AE8s9P9S2YgWR7Tld2PsDc6Vky2TmSv-9rTCOBro";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
